import { combineSlices, configureStore } from "@reduxjs/toolkit";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import { winnersApi } from "./features/api/winners";
import { winnersFeedApi } from "./features/api/winnersFeed";
import { carsSlice } from "./features/cars/carsSlice";
import { cartSlice } from "./features/cart/cartSlice";
import { categoriesSlice } from "./features/categories/slice";
import { deviceSlice } from "./features/device/slice";
import { headerSlice } from "./features/header/headerSlice";
import { modalSlice } from "./features/modal/modalSlice";
import { winnersSlice } from "./features/winners/winnersSlice";
import { rewardsApi } from "./features/api/rewards";
import { membersHomeApi } from "./features/api/membersHome";
import { commonApi } from "./features/api/common";
import { lifestyleApi } from "./features/api/lifestyle";

export interface LazyLoadedSlices {}

const staticSlices = {
  [winnersApi.reducerPath]: winnersApi.reducer,
  [rewardsApi.reducerPath]: rewardsApi.reducer,
  [winnersFeedApi.reducerPath]: winnersFeedApi.reducer,
  [membersHomeApi.reducerPath]: membersHomeApi.reducer,
  [commonApi.reducerPath]: commonApi.reducer,
  [lifestyleApi.reducerPath]: lifestyleApi.reducer,
  winners: winnersSlice.reducer,
  cars: carsSlice.reducer,
  modal: modalSlice.reducer,
  cart: cartSlice.reducer,
  header: headerSlice.reducer,
  competitionsCategories: categoriesSlice.reducer,
  device: deviceSlice.reducer,
};

export const rootReducer = combineSlices(staticSlices).withLazyLoadedSlices<LazyLoadedSlices>();

export const makeStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(
        winnersApi.middleware,
        rewardsApi.middleware,
        winnersFeedApi.middleware,
        membersHomeApi.middleware,
        commonApi.middleware,
        lifestyleApi.middleware
      ),
  });

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
